var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailInbound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.4 20.4",
    enableBackground: "new 0 0 20.4 20.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3, -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Email_Icon_BG-2",
    fill: "#6A00C4",
    d: "M10.2,0c5.7,0,10.2,4.6,10.2,10.2s-4.5,10.2-10.2,10.2S0,15.9,0,10.2l0,0 C0,4.5,4.5,0,10.2,0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    fill: "#FFFFFF",
    d: "M11.4,3.3H3.1c-0.6,0-1,0.5-1,1v6.2c0,0.6,0.5,1,1,1h8.3c0.6,0,1-0.5,1-1V4.4 C12.4,3.8,11.9,3.3,11.4,3.3z M11.4,5.4L7.2,8L3.1,5.4v-1L7.2,7l4.1-2.6L11.4,5.4L11.4,5.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailInbound);
export default __webpack_public_path__ + "static/media/email-inbound.48467f64997c41fc5eec6e3a6458dc21.svg";
export { ForwardRef as ReactComponent };